import React, { useState } from 'react';
import SvgIcon from './SvgIcon';

const FirstLoginResetModal = ({ user, onPasswordResetSuccess }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');

    if (!newPassword || newPassword.length < 6) {
      setErrorMsg('Password must be at least 6 characters long.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setErrorMsg('Passwords do not match.');
      return;
    }

    setIsSubmitting(true);

    try {
      const targetAccountType = user.accountType || (user.role === 'Trainer' ? 'trainer' : user.role === 'Learner' ? 'learner' : 'admin');
      const targetId = user.id || user.learnerId || user.adminId || user.trainerId;

      const response = await fetch('/api/auth/reset-first-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          accountType: targetAccountType,
          id: targetId,
          newPassword
        })
      });

      const data = await response.json();

      if (response.ok && data.status === 'success') {
        const mustComplete = user.MustCompleteProfile === 1 || user.mustCompleteProfile === 1 || user.mustCompleteProfile === true;
        if (onPasswordResetSuccess) {
          onPasswordResetSuccess({ mustCompleteProfile: mustComplete });
        }
      } else {
        setErrorMsg(data.message || 'Failed to reset password.');
      }
    } catch (err) {
      console.error(err);
      setErrorMsg('Failed to connect to server.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="admin-modal-overlay" style={{ zIndex: 20000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div className="first-login-card">
        
        {/* Centered Lock Badge Header */}
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <div style={{ width: '52px', height: '52px', borderRadius: '50%', backgroundColor: '#e0e7ff', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 0.85rem auto', color: '#4f46e5' }}>
            <SvgIcon name="lock" size={26} />
          </div>
          <h2 style={{ margin: '0 0 0.5rem 0', fontSize: '1.35rem', fontWeight: '800', color: '#0f172a' }}>
            First Login - Password Reset
          </h2>
          <p style={{ margin: 0, fontSize: '0.85rem', color: '#64748b', lineHeight: '1.5' }}>
            Welcome to Cloudonuts {user?.role === 'Trainer' ? 'Trainer ' : ''}Dashboard! As this is your first login, please set a new secure password for your account.
          </p>
        </div>

        {errorMsg && (
          <div style={{ backgroundColor: '#fef2f2', border: '1px solid #fecaca', color: '#991b1b', padding: '0.65rem 0.85rem', borderRadius: '8px', marginBottom: '1.25rem', fontSize: '0.825rem', textAlign: 'center' }}>
            {errorMsg}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ width: '100%', boxSizing: 'border-box' }}>
          <div style={{ marginBottom: '1.25rem', textAlign: 'left' }}>
            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: '700', color: '#334155', marginBottom: '0.45rem', textAlign: 'left' }}>
              New Password
            </label>
            <div className="first-login-input-wrapper">
              <input
                type={showNewPassword ? 'text' : 'password'}
                className="first-login-input"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                data-hj-suppress
              />
              <button
                type="button"
                className="first-login-toggle-btn"
                onClick={() => setShowNewPassword(prev => !prev)}
                title={showNewPassword ? "Hide password" : "Show password"}
              >
                <SvgIcon name={showNewPassword ? 'eyeOff' : 'eye'} size={18} />
              </button>
            </div>
          </div>

          <div style={{ marginBottom: '1.5rem', textAlign: 'left' }}>
            <label style={{ display: 'block', fontSize: '0.8rem', fontWeight: '700', color: '#334155', marginBottom: '0.45rem', textAlign: 'left' }}>
              Confirm New Password
            </label>
            <div className="first-login-input-wrapper">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                className="first-login-input"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                data-hj-suppress
              />
              <button
                type="button"
                className="first-login-toggle-btn"
                onClick={() => setShowConfirmPassword(prev => !prev)}
                title={showConfirmPassword ? "Hide password" : "Show password"}
              >
                <SvgIcon name={showConfirmPassword ? 'eyeOff' : 'eye'} size={18} />
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="first-login-submit-btn"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Saving Password...' : 'Set New Password & Continue'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default FirstLoginResetModal;

